import { useState, useEffect } from "react";
import OptimizedImage from "../OptimizedImage";

interface FadingCarouselProps {
  images: string[];
}

export const FadingCarousel = ({ images }: FadingCarouselProps) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    if (images.length <= 1) return;

    const timer = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        setIsTransitioning(false);
      }, 500);
    }, 3000);

    return () => clearInterval(timer);
  }, [images.length]);

  if (images.length === 0) {
    return (
      <div className="relative w-full h-full bg-gray-200 animate-pulse" />
    );
  }

  return (
    <div className="relative w-full h-full overflow-hidden">
      <OptimizedImage
        src={images[currentImageIndex]}
        alt="Treatment preview"
        className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
          isTransitioning ? 'opacity-0' : 'opacity-100'
        }`}
        priority={currentImageIndex === 0}
      />
    </div>
  );
};